import { render, staticRenderFns } from "./EditDetailsCard.vue?vue&type=template&id=ed864fd8"
import script from "./EditDetailsCard.vue?vue&type=script&lang=js"
export * from "./EditDetailsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports